import React from 'react';
import SimpleImportMap from "../SimpleImportMap";
import * as f from "../../common/Funcs";
import {BaseButton, BaseTextButton} from "../../Base/BaseButtons";
import {disableInteractions} from "../MapControls";
import {Draw, Modify, Snap} from "ol/interaction";
import * as g from "../../common/gisFuncs";
import {Vector as VectorSource} from "ol/source";
import {Vector as VectorLayer} from "ol/layer";
import intersect from "@turf/intersect";
import {Circle as CircleStyle, Fill, Stroke, Style} from "ol/style";
import landstyle from "../styles/landspol";
import admstyle from "../styles/admpol";
import {Panel} from "@sencha/ext-react-modern";

let context = null;
const keyName = "ZmuEaSingleMap";
export default class ZmuEaSingleMap extends SimpleImportMap {

    static defaultProps = {
        mapButtonNames: ['upload', 'download', 'edit', 'cut'],
        layerNames: [
            {
                layerName: 'landspol', hidden: false, type: 'own', styleFunction: landstyle
            },
            {
                layerName: 'admpol', hidden: false, type: 'own', styleFunction: admstyle
            },
        ],
        load: 'auto',
        geomType: 'Polygon'
    }

    constructor(props) {
        super(props);
        context = this;
        if (!context.topMenuButtons) context.topMenuButtons = [];
    }

    /*дополнительные инструменты на карте*/
    getAdditControls() {
        return []
    }

    isEditRight(context) {
        const page = context.props.parent.props.parent;
        return page.isEditRight(context.props.rights) &&
            context.featureOn;
    }

    addEditButton(buttons) {
        const context = this;
        if (!context.isEditRight(context)) return;
        const index = context._buttonIndex !== undefined ? context._buttonIndex++ : 1;
        context.topMenuButtons[index] = ({
            iconCls: 'x-fa fa-edit',
            html: `<label class="menu-label">${'редактировать'}</label>`,
            handler: () => context.editTool(context),
            hidden: !(context.isEditRight(context))
        })
        // buttons[1] = (<EditButton key={'editButton'} pressed={(this.state.inEdit)} func={() => this.editTool()}/>);
    }

    addUploadButton(buttons) {
        const context = this;
        if (!context.isEditRight(context) || context.geomType == 'Point') return;
        const fileElement = document.createElement('input');
        fileElement.type = 'file';
        fileElement.id = 'map_file';
        fileElement.className = 'upload-file-input hidden';
        fileElement.addEventListener("change", (field) => {
            context.uploadTool(field, context)
        });
        document.body.appendChild(fileElement);
        //по клику - клик на инпуте
        //на change input-a  запрос на загрузку файла и загрузить если да
        const index = context._buttonIndex !== undefined ? context._buttonIndex++ : 3;
        context.topMenuButtons[index] = ({
            iconCls: 'x-fa fa-upload',
            html: `<label class="menu-label">${f.locale('path_upload')}</label>`,
            tooltip: f.locale('path_upload'),
            handler: () => {
                fileElement.click();
            }
        })
    }

    addDownloadButton(buttons) {
        const context = this;
        const index1 = context._buttonIndex !== undefined ? context._buttonIndex++ : 4;
        context.topMenuButtons[index1] = ({
            iconCls: 'x-fa fa-download',
            html: `<label class="menu-label">${f.locale('shp') || 'shp'}</label>`,
            tooltip: f.locale('shp'),
            handler: () => {
                context.downloadTool('shp', context);
            }
        })
        const index2 = context._buttonIndex !== undefined ? context._buttonIndex++ : 5;
        context.topMenuButtons[index2] = ({
            iconCls: 'x-fa fa-download',
            html: `<label class="menu-label">${f.locale('gpx') || 'gpx'}</label>`,
            tooltip: f.locale('gpx'),
            handler: () => {
                context.downloadTool('gpx', context);
            }
        })
    }

    addCutButton(buttons) {
        const context = this;
        if (!context.isEditRight(context)) return buttons;
        if (!buttons) buttons = [];
        // Кнопка "обрезать" - скрывается при начале обрезки
        const cutIndex = context._buttonIndex !== undefined ? context._buttonIndex++ : 0;
        context.topMenuButtons[cutIndex] = {
            iconCls: 'fa fa-cut',
            html: `<label class="menu-label">${'обрезать'}</label>`,
            handler: (e) => {
                context.cutTool(e)
            },
            hidden: context.state.isCut
        };
        // Сохраняем индекс кнопки обрезки для обновления видимости
        context._cutButtonIndex = cutIndex;
        
        // Кнопка "прервать" - появляется при начале обрезки
        const cancelIndex = context._buttonIndex !== undefined ? context._buttonIndex++ : context.topMenuButtons.length;
        context.topMenuButtons[cancelIndex] = {
            iconCls: 'fa fa-times',
            html: `<label class="menu-label">${'прервать'}</label>`,
            handler: (e) => {
                context.cancelCutPolygon(context)
            },
            hidden: !context.state.isCut
        };
        // Сохраняем индекс кнопки прерывания для обновления видимости
        context._cancelCutButtonIndex = cancelIndex;
        
        // Кнопка "завершить" - появляется при начале обрезки
        const finishIndex = context._buttonIndex !== undefined ? context._buttonIndex++ : context.topMenuButtons.length;
        context.topMenuButtons[finishIndex] = {
            iconCls: 'fa fa-check',
            html: `<label class="menu-label">${'завершить'}</label>`,
            handler: (e) => {
                context.finishCutPolygon(context)
            },
            hidden: !context.state.isCut
        };
        // Сохраняем индекс кнопки завершения для обновления видимости
        context._finishCutButtonIndex = finishIndex;
        buttons[0] = (<BaseButton key={'cutButton'} pressed={(this.state.inEdit)} iconCls={'fa fa-cut'}
                                  func={(e) => this.cutTool(e)}/>);
        buttons[20] = (<BaseTextButton key={'okButton'} hidden={true} ref={(r) => context.ok = r} text={'Завершить'}
                                       func={(e) => this.finishCutPolygon(context)}/>);
    }

    cutTool(e) {
        if (window.mapDebug) console.debug('cut start');
        const context = this;
        if (!context.state.isCut) {
            disableInteractions(context.olMap);
        }
        if (context.state.isCut) {
            context.setState({isCut: false}, () => {
                context.cutSource.clear();
                // Обновляем видимость всех кнопок
                context.updateCutButtonsVisibility(false);
                // context.ok.cmp.hide();
            })
        } else {
            const cut = {};
            context.setState({isCut: true}, () => {
                // Обновляем видимость всех кнопок
                context.updateCutButtonsVisibility(true);
                const editCut = (context, e) => {
                    const source = context.cutSource;
                    if (!source) return;
                    if (e.feature) {
                        // context.ok.cmp.show();
                        disableInteractions(context.olMap);
                        return;
                        const modify = new Modify({
                            source: source,
                            deleteCondition: function (event) {
                                return event.originalEvent.altKey;
                            }
                        });
                        context.olMap.addInteraction(modify);
                        const snap = new Snap({source: source});
                        context.olMap.addInteraction(snap);
                        modify.on('modifyend', (event) => {
                            let geoJson = g.toGeoJson(source.getFeatures()[0]);
                        });
                    }
                }
                /*добавляем слой для обрезки*/
                const addCutLayer = (context) => {
                    context.cutSource = new VectorSource();
                    context.cutLayer = new VectorLayer({
                        source: context.cutSource,
                        style: new Style({
                            fill: new Fill({
                                color: 'rgba(255, 255, 255, 0.2)',
                            }),
                            stroke: new Stroke({
                                color: [255, 125, 0, 1],
                                width: 2,
                            }),
                            image: new CircleStyle({
                                radius: 7,
                                fill: new Fill({
                                    color: [255, 125, 0, 1],
                                }),
                            }),
                        }),
                    });
                    context.cutLayer.statusName = 'cut';
                    context.cutLayer.pos = 100;
                    context.olMap.addLayer(context.cutLayer);
                    context.orderLayers(context);

                }
                /*включаем обрезку территории */
                if (!context.cutSource) addCutLayer(context);
                cut.draw = new Draw({
                    source: context.cutSource,
                    type: context.props.geomType,
                    style: new Style({
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 0.2)',
                        }),
                        stroke: new Stroke({
                            color: 'rgba(0, 0, 0, 0.5)',
                            lineDash: [10, 10],
                            width: 2,
                        }),
                        image: new CircleStyle({
                            radius: 5,
                            stroke: new Stroke({
                                color: 'rgba(0, 0, 0, 0.7)',
                            }),
                            fill: new Fill({
                                color: 'rgba(255, 255, 255, 0.2)',
                            }),
                        }),
                    }),
                });
                cut.draw.interactionName = context.props.geomType;
                // Сохраняем ссылку на взаимодействие для восстановления после смены подложки
                context._cutDrawInteraction = cut.draw;
                context.olMap.addInteraction(cut.draw);
                cut.draw.on('drawend', function (e) {
                    editCut(context, e);
                });
            })
        }

    }

    /*Переопределяем метод setTopos для восстановления взаимодействия обрезки после смены подложки*/
    setTopos(topoName) {
        const context = this;
        // Сохраняем состояние обрезки перед сменой подложки
        const wasInCutMode = context.state.isCut;
        const hadDrawInteraction = context._cutDrawInteraction && 
            context.olMap.getInteractions().getArray().includes(context._cutDrawInteraction);
        
        // Вызываем родительский метод
        super.setTopos(topoName);
        
        // Восстанавливаем взаимодействие обрезки, если оно было активно
        if (wasInCutMode && context.cutSource && context.cutLayer) {
            // Всегда восстанавливаем взаимодействие после смены подложки, так как оно могло быть удалено
            context.restoreCutInteraction();
        }
    }

    /*Восстановление взаимодействия обрезки*/
    restoreCutInteraction() {
        const context = this;
        if (!context.cutSource || !context.cutLayer || !context.state.isCut) return;
        
        // Проверяем, что взаимодействие не на карте
        const interactionOnMap = context._cutDrawInteraction && 
            context.olMap.getInteractions().getArray().includes(context._cutDrawInteraction);
        
        if (!interactionOnMap) {
            // Пересоздаем взаимодействие рисования
            const cutDraw = new Draw({
                source: context.cutSource,
                type: context.props.geomType,
                style: new Style({
                    fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.2)',
                    }),
                    stroke: new Stroke({
                        color: 'rgba(0, 0, 0, 0.5)',
                        lineDash: [10, 10],
                        width: 2,
                    }),
                    image: new CircleStyle({
                        radius: 5,
                        stroke: new Stroke({
                            color: 'rgba(0, 0, 0, 0.7)',
                        }),
                        fill: new Fill({
                            color: 'rgba(255, 255, 255, 0.2)',
                        }),
                    }),
                }),
            });
            cutDraw.interactionName = context.props.geomType;
            context._cutDrawInteraction = cutDraw;
            context.olMap.addInteraction(cutDraw);
            
            // Восстанавливаем обработчик события (используем ту же логику, что и в cutTool)
            cutDraw.on('drawend', function (e) {
                const source = context.cutSource;
                if (!source) return;
                if (e.feature) {
                    disableInteractions(context.olMap);
                    return;
                }
            });
        }
    }

    /*Обновление видимости кнопок обрезки*/
    updateCutButtonsVisibility(isCut) {
        const context = this;
        // Скрываем/показываем кнопку "обрезать"
        if (context._cutButtonIndex !== undefined && context.topMenuButtons[context._cutButtonIndex]) {
            context.topMenuButtons[context._cutButtonIndex].hidden = isCut;
        }
        // Показываем/скрываем кнопку "прервать"
        if (context._cancelCutButtonIndex !== undefined && context.topMenuButtons[context._cancelCutButtonIndex]) {
            context.topMenuButtons[context._cancelCutButtonIndex].hidden = !isCut;
        }
        // Показываем/скрываем кнопку "завершить"
        if (context._finishCutButtonIndex !== undefined && context.topMenuButtons[context._finishCutButtonIndex]) {
            context.topMenuButtons[context._finishCutButtonIndex].hidden = !isCut;
        }
    }

    /*Прерываем обрезку территории */
    cancelCutPolygon(context) {
        if (window.mapDebug) console.debug('cut cancel');
        const ctx = context || this;
        // Удаляем взаимодействие рисования, если оно есть
        if (ctx.olMap) {
            const drawInteraction = ctx.olMap.getInteractions().getArray().find(i => i.interactionName === ctx.props.geomType);
            if (drawInteraction) {
                ctx.olMap.removeInteraction(drawInteraction);
            }
            // Удаляем сохраненную ссылку на взаимодействие
            ctx._cutDrawInteraction = null;
            // Удаляем слой обрезки, если он был создан
            if (ctx.cutLayer) {
                ctx.olMap.removeLayer(ctx.cutLayer);
                ctx.cutLayer = null;
            }
            disableInteractions(ctx.olMap);
        }
        // Очищаем и удаляем источник обрезки
        if (ctx.cutSource) {
            ctx.cutSource.clear();
            ctx.cutSource = null;
        }
        // Выходим из режима обрезки
        ctx.setState({isCut: false}, () => {
            // Обновляем видимость всех кнопок
            ctx.updateCutButtonsVisibility(false);
        });
    }

    /*Завершаем обрезку территории */
    finishCutPolygon(context) {
        if (window.mapDebug) console.debug('cut finish');
        const ctx = context;
        // Удаляем взаимодействие рисования
        if (ctx.olMap && ctx._cutDrawInteraction) {
            const drawInteraction = ctx.olMap.getInteractions().getArray().find(i => i === ctx._cutDrawInteraction);
            if (drawInteraction) {
                ctx.olMap.removeInteraction(drawInteraction);
            }
            ctx._cutDrawInteraction = null;
        }
        // disableInteractions(olMap);
        ctx.setState({isCut: false}, () => {
            // Обновляем видимость всех кнопок
            ctx.updateCutButtonsVisibility(false);
            f.confirm('Обрезать территорию по выделению?', (e) => {
                if (e) {
                    if (window.IasConfig.devMode) console.debug(`${keyName}`);
                    const ea = ctx.featuresSource.getFeatures().find(f => f.values_.source == 'eapol');
                    const f1 = g.toGeoJson(ea);
                    const f2 = g.toGeoJson(ctx.cutSource.getFeatures()[0]);
                    const f3 = intersect(f1, f2);
                    debugger;
                    ea.getGeometry().setCoordinates([f3.geometry.coordinates]);
                    ctx.featuresSource.getFeatures().find(f => f.values_.source == 'eapol').getGeometry().setCoordinates([f3.geometry.coordinates]);
                    ctx.setToField(ea);
                    // olMap.cutSource.clear();
                }
                ctx.cutSource.clear();
                if (ctx.ok && ctx.ok.cmp) ctx.ok.cmp.hide();
            })
        })
    }

    setToField(feature) {
        const context = this;
        // context.props.parent.gisFeature = feature;
        const coords = feature.getGeometry().getCoordinates();
        let object = {
            type: feature.getGeometry().getType(),
            crs: {"type": "name", "properties": {"name": "urn:ogc:def:crs:EPSG:3857"}}
        };
        object.coordinates = coords;
        // context.geomField.cmp.setValue(JSON.stringify(object));
        this.geomField = JSON.stringify(object);
    }

    /*

    componentDidUpdate(prevProps, prevState, snapshot) {
        const context=this;
        if (prevProps.rowId!=context.props.rowId) {
            context.setState({buttons:context.addButtons()});
        }
        super.componentDidUpdate(prevProps, prevState, snapshot);
        
        // Восстанавливаем взаимодействие обрезки, если оно было удалено (например, при закрытии панели топооснов)
        if (context.state.isCut && context.cutSource && context.cutLayer && context.olMap) {
            // Проверяем наличие взаимодействия на карте
            const interactionOnMap = context._cutDrawInteraction && 
                context.olMap.getInteractions().getArray().includes(context._cutDrawInteraction);
            
            if (!interactionOnMap) {
                // Восстанавливаем взаимодействие, если оно было удалено
                setTimeout(() => {
                    if (context.state.isCut && context.cutSource && context.cutLayer) {
                        context.restoreCutInteraction();
                    }
                }, 100);
            }
        }
    }

    isEditRight(context) {
        const page=context.props.parent.props.parent;
        return page.isEditRight(context.props.rights);
    }

    getValues(file) {
        if (window.IasConfig.devMode) console.debug(`${keyName} getBaseValues`, context.form.cmp.getValues());
        let result = new FormData();
        result.append('file', file);
        return result;
    }

    render() {
        const context = this;
        const height = context.props.height;
        const width = context.props.width;
        const readonly = context.props.readonly;

        let toolBox = '';
        if (!readonly) {
            const buttons = context.state.buttons;
            toolBox = <Panel layout={'vbox'} margin={3} key={`toolBoxPanel${keyName}`} name={`toolBoxPanel${keyName}`}>
                {buttons}
            </Panel>;
        }
        return <Panel
            layout={'hbox'} margin="3"
            key={`mapPanel${keyName}`}
            name={`mapPanel${keyName}`}
            className={'map-panel'}
            width={width}
            height={height}
            ref={p => context.cmp = p}
        >
            <div className={'map-container'} style={{height: height, width: width}}
                 ref={(m) => context.mapDiv = m}/>
            {toolBox}
        </Panel>;
    }

*/
    render() {
        const context = this;
        const height = context.props.height;
        const width = context.props.width;
        const readonly = context.props.readonly;
        context.addButtons();
        let toolBox = '';
        if (!readonly) {
            const buttons = context.state.buttons;
            // toolBox = <Panel layout={'hbox'} margin={3} key={`toolBoxPanel${keyName}`} name={`toolBoxPanel${keyName}`}>
            // toolBox = <Panel layout={'vbox'} margin={3} key={`toolBoxPanel${keyName}`} name={`toolBoxPanel${keyName}`}>
            //     {buttons}
            // </Panel>;
            toolBox = <Panel
                region={"top"} margin="3"
                layout={'fit'}
                height={'25px'}
                cls={'edit-window-panel'}
                key={`toolBoxPanel${keyName}`}
                tools={context.topMenuButtons}
                ref={p => {
                }}/>;
        }

        return <Panel
            // layout={'vbox'} margin="3"
            layout={'vbox'} margin="3"
            key={`mapPanel${keyName}`}
            name={`mapPanel${keyName}`}
            className={'map-panel'}
            width={width}
            height={height}
            ref={p => {
                if (p) {
                    context.cmp = p;
                }
            }}
        >

            <Panel bodyCls={`map-${keyName}`}
                   key={'mapcont'}
                   width={'100%'}
                   ref={(m) => {
                       if (m?.cmp)
                           context.mapCmp = m.cmp;
                   }}
                   listeners={
                       {
                           resize: (element, info, eOpts) => {
                               g.mapResize(context);
                           }
                       }
                   }
            >
                {toolBox}
            </Panel>
        </Panel>;
    }
}
